import { heroData } from '@/mocks/home';

export default function Hero() {
  const { preTag, h1, slogan, description, stats, primaryCta, secondaryCta } = heroData;

  return (
    <section
      id="hero"
      className="relative w-full min-h-[420px] md:min-h-[600px] flex items-center overflow-hidden"
    >
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Cinematic%20artistic%20composition%20with%20floating%20movie%20posters%20and%20film%20elements%20in%20warm%20amber%20and%20coral%20tones%2C%20soft%20dramatic%20lighting%2C%20abstract%20film%20reel%20motifs%2C%20elegant%20editorial%20design%20with%20dark%20warm%20background%2C%20golden%20accents%2C%20high%20detail%20cinematic%20atmosphere&width=1600&height=900&seq=hero-bg-main&orientation=landscape"
          alt="91免费在线视频 - 精品影视在线播放平台"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-black/35 to-black/60"></div>
      </div>

      <div className="relative w-full px-4 md:px-6 py-16 md:py-20">
        <div className="max-w-7xl mx-auto flex flex-col lg:flex-row items-center gap-8 lg:gap-12">
          <div className="flex-1 w-full text-center lg:text-left">
            <span className="inline-block px-4 py-1.5 rounded-full bg-accent-500/20 border border-accent-400/30 text-accent-200 text-xs md:text-sm mb-5 whitespace-nowrap">
              {preTag}
            </span>

            <h1 className="text-2xl md:text-4xl lg:text-5xl font-heading font-bold text-white leading-tight mb-4">
              {h1}
            </h1>

            <p className="text-base md:text-lg text-white/80 font-body mb-6">
              {slogan}
            </p>

            <p className="text-sm md:text-base text-white/65 leading-relaxed max-w-xl mx-auto lg:mx-0 mb-8">
              {description}
            </p>

            <div className="flex flex-wrap items-center justify-center lg:justify-start gap-3 md:gap-5 mb-8">
              {stats.map((stat, idx) => (
                <div key={idx} className="flex items-center gap-2 bg-white/10 backdrop-blur-sm rounded-lg px-4 py-2.5">
                  <span className="text-accent-400 text-xs md:text-sm font-medium whitespace-nowrap">{stat.label}</span>
                  <span className="text-white/80 text-xs md:text-sm whitespace-nowrap">{stat.value}</span>
                </div>
              ))}
            </div>

            <div className="flex flex-col sm:flex-row items-center justify-center lg:justify-start gap-3">
              <a
                href={primaryCta.href}
                className="w-full sm:w-auto inline-flex items-center justify-center px-6 py-3 bg-primary-500 hover:bg-primary-600 text-white text-sm font-medium rounded-md transition-colors cursor-pointer whitespace-nowrap"
              >
                {primaryCta.text}
                <i className="ri-arrow-right-line ml-2"></i>
              </a>
              <a
                href={secondaryCta.href}
                className="w-full sm:w-auto inline-flex items-center justify-center px-6 py-3 bg-white/10 hover:bg-white/20 backdrop-blur-sm text-white text-sm font-medium rounded-md border border-white/20 transition-colors cursor-pointer whitespace-nowrap"
              >
                {secondaryCta.text}
                <i className="ri-fire-line ml-2"></i>
              </a>
            </div>
          </div>

          <div className="flex-1 w-full max-w-md lg:max-w-lg">
            <div className="relative rounded-lg overflow-hidden shadow-2xl">
              <img
                src="https://readdy.ai/api/search-image?query=Artistic%20collage%20of%20classic%20and%20modern%20film%20moments%20in%20warm%20golden%20and%20coral%20tones%2C%20cinematic%20composition%20with%20film%20strip%20border%2C%20vintage%20projector%20light%20effect%2C%20elegant%20movie%20poster%20style%2C%20high%20detail%2C%20rich%20atmospheric%20mood&width=800&height=600&seq=hero-visual-main&orientation=landscape"
                alt="91免费在线视频精品影视推荐"
                className="w-full h-auto object-cover"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}